<template>
  <div class="bounty-info">
    <BountyReward
      class="bounty-info__money"
      :amount-type="bounty.amountType"
      :type="bounty.rewardType"
      :val="bounty.bonus"
      :coin="bounty.payment"
    />
    <h2 class="g-title title g-font-mid">{{ bounty.title }}</h2>
    <div class="labels">
      <LabelItem v-for="item in bounty.labels" class="labels__item" :key="item.id" :label="item.value"/>
    </div>
    <InfoItem :label="$t('personal.difficulty')">{{ difficulty }}</InfoItem>
    <InfoItem :label="$t('personal.remaining')">{{ remain }}</InfoItem>
    <InfoItem :label="$t('personal.submit')">{{ bounty.submit }}</InfoItem>
    <UserItem class="user-info" :avatar="author.avatar" :name="author.name" :ont="author.id"/>
    <div class="user-prop">
      <div class="user-prop__label">{{ $t('bounty.mail') }}：</div>
      <div class="user-prop__value">{{ bounty.contactEmail }}</div>
    </div>
    <ManageButtons
      v-if="bounty.status===2&&author.id&&author.id!==$store.state.id"
      class="bounty-info__btn"
      :apply-status="bounty.applyStatus"
      :submit-status="bounty.submitStatus"
      :outer-link="bounty.outerLink"
      @submit="emitSubmit"
      @apply="fetchBounty"
      @login="fetchBounty"
    />
    <UserMedia class="user-media" :twitter="author.twitter" :github="author.github" :linkedin="author.linkedin" />
    <MarkdownViewer class="bounty-info__des" :value="bounty.description" />
  </div>
</template>

<script>
import LabelItem from '@/components/LabelItem.vue';
import InfoItem from '@/components/InfoItem.vue';
import UserItem from '@/components/UserItem.vue';
import UserMedia from '@/components/UserMedia.vue';
import ManageButtons from '@/views/Bounty/ManageButtons.vue';
import { getRemainingLabel } from '@/utils/business';
import URLS from '@/config/url';
import { BOUNTY_STATUS, ROLES } from '@/config/enum';
import MarkdownViewer from '@/components/MarkdownViewer.vue';
import BountyReward from '@/components/BountyReward.vue';

export default {
  name: 'BountyInfo',
  components: {
    BountyReward,
    MarkdownViewer,
    ManageButtons,
    UserMedia,
    UserItem,
    InfoItem,
    LabelItem,
  },
  data() {
    return {
      bounty: {
        title: '',
        description: '',
        labels: [],
        difficulty: 1,
        deadline: 0,
        submit: 0,
        applyStatus: BOUNTY_STATUS.unsubmitted,
        submitStatus: BOUNTY_STATUS.unsubmitted,
        rewardType: 1,
        bonus: 0,
        payment: '',
        status: 1,
        author: '',
        outerLink: '',
        contactEmail: '',
        amountType: 2,
      },
      author: {
        name: '',
        avatar: '',
        id: '',
        mail: '',
        twitter: '',
        github: '',
        linkedin: '',
      },
      ROLES,
    };
  },
  computed: {
    remain() {
      return getRemainingLabel(this.bounty.status, this.bounty.deadline);
    },
    difficulty() {
      return this.$t(`personal.difficulty${this.bounty.difficulty}`);
    },
  },
  methods: {
    emitSubmit() {
      this.$emit('clickSubmit', this.bounty.submitStatus);
    },
    fetchAuthorInfo() {
      this.$request({
        url: URLS.getInfo,
        params: {
          ontid: this.bounty.author,
        },
      }).then(({ result }) => {
        this.author.name = result.name || '';
        this.author.id = result.user_ontid;
        this.author.avatar = result.avatar || '';
        this.author.mail = result.email || '';
        this.author.twitter = result.twitter;
        this.author.github = result.github;
        this.author.linkedin = result.linkedin;
      });
    },
    fetchBounty() {
      this.$request({
        url: URLS.bountyDetail,
        params: {
          id: this.$route.query.id,
          ontid: this.$store.getters.id,
        },
      }).then(({ result }) => {
        this.bounty.title = result.title;
        this.bounty.description = result.description;
        this.bounty.labels = result.types || [];
        this.bounty.difficulty = result.level;
        this.bounty.deadline = result.expire_time;
        this.bounty.submit = result.submits;
        this.bounty.applyStatus = result.apply_status;
        this.bounty.submitStatus = result.submit_status;
        this.bounty.rewardType = result.reward_type;
        this.bounty.payment = result.reward_token;
        this.bounty.bonus = result.reward_type === 1 ? result.reward_usdt : result.reward_amount;
        this.bounty.status = result.status;
        this.bounty.author = result.creator;
        this.bounty.outerLink = result.outer_link || '';
        this.bounty.contactEmail = result.contact_email || '';
        this.bounty.amountType = result.amount_type;
        this.fetchAuthorInfo();
      });
    },
  },
  created() {
    this.fetchBounty();
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/styles/var.scss';

  .bounty-info {
    padding: $padding-common $padding-common $padding-lg $padding-common;
  }

  .title {
    max-width: 560px;
    font-size: 36px;
    line-height: 42px;
  }

  .labels {
    margin-top: 10px;
    margin-bottom: 30px;
    max-width: 600px;
    overflow: hidden;
  }

  .labels__item {
    margin-top: 10px;
    margin-right: 10px;
  }

  .user-info {
    margin-top: 30px;
  }

  .user-prop {
    margin-top: 20px;
    line-height: 16px;
    font-size: $font-size-sm;
  }

  .user-prop__label {
    display: inline-block;
    width: 52px;
    color: var(--color-content);
  }

  .user-prop__value {
    display: inline-block;
  }

  .user-media {
    display: inline-block;
    margin-top: $padding-sm;
  }

  .bounty-info__btn {
    float: right;
  }

  .bounty-info__money {
    float: right;
  }

  .bounty-info__des {
    margin-top: $padding-common;
    padding-top: $padding-sm;
    border-top: 1px solid var(--border-common);
  }
</style>
